// For Loading
export const TOGGLE_LOADING = 'TOGGLE_LOADING'
// For Unauthorization 
export const UNAUTHORIZED_SETTING = "UNAUTHORIZED_SETTING"
// For Fetching Token
export const FETCH_TOKEN = "FETCH_TOKEN"
// For Fetching User list
export const FETCH_USER_LIST = "FETCH_USER_LIST"
// For fetching user details
export const FETCH_USER_DETAILS = "FETCH_USER_DETAILS"
// For fetching timezone
export const FETCH_TIMEZONE_LIST = "FETCH_TIMEZONE_LIST"
// For fetching Billing Url
export const FETCH_BILLING_URL = "FETCH_BILLING_URL"
// For fetching Lookup Key
export const FETCH_LOOKUP_KEY = "FETCH_LOOKUP_KEY"
// For fetching Manage billing
export const FETCH_MANAGE_BILLING = "FETCH_MANAGE_BILLING"
// For fetching Manage billing
export const FETCH_CURRENT_PLAN = "FETCH_CURRENT_PLAN"
// For fetching notification check
export const NOTIFICATION_CHECK_LIST = "NOTIFICATION_CHECK_LIST"
// For fetching calendly
export const FETCH_CALENDLY_URL = "FETCH_CALENDLY_URL"
// For fetching calendly
export const CALENDLY_DATA = "CALENDLY_DATA"
// For fetching schedule
export const FETCH_SCHEDULE_LIST = "FETCH_SCHEDULE_LIST"
// For fetching Stripe Updated data
export const STRIPE_UPDATED_DATA = "STRIPE_UPDATED_DATA"
// FOR fetching event list
export const FETCH_EVENT_LIST = "FETCH_EVENT_LIST"
// FOR fetching event DETAIL
export const FETCH_EVENT_DETAIL = "FETCH_EVENT_DETAIL"

export const FETCH_GOOGLE_CALENDAR_URL = "FETCH_GOOGLE_CALENDAR_URL"
// For field data
export const FIELDS_DATA = "FIELDS_DATA"
// For hubspot connection
export const HUBSPOT_STATUS = "HUBSPOT_STATUS"
// For hubspot connection
export const HUBSPOT_MAPPED_DATA = "HUBSPOT_MAPPED_DATA"
// For hubspot connection
export const HUBSPOT_DELETE_DATA = "HUBSPOT_DELETE_DATA"

export const HUBSPOT_SYNC_DATA = "HUBSPOT_SYNC_DATA"
// For user PRofile
export const FETCH_USER_DATA = "FETCH_USER_DATA"

export const FETCH_EVENT_POPUP_LIST = "FETCH_EVENT_POPUP_LIST"
// For Selecting Calendar
export const FETCH_SELECTED_CALENDAR = "FETCH_SELECTED_CALENDAR"
// For Selecting Calendar
export const ZOI_VISIBILITY = "ZOI_VISIBILITY"
// For Plan Details
export const PLAN_DETAILS = "PLAN_DETAILS"
// For Intel Settings
export const INTEL_SETTING = "INTEL_SETTING"
// For Payment History
export const PAYMENT_HISTORY = "PAYMENT_HISTORY"

export const NOTIFICATION_DATA = 'NOTIFICATION_DATA';

